import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

/* Images */

import { banners } from '../Assets/Banner/banners-paths'

const Home = () => {
  return (
    <>
      <Carousel
        autoPlay
        infiniteLoop
        interval={4000}
        showArrows={true}
        showIndicator={false}
        showStatus={false}
        showThumbs={false}
        onSwipeStart={e => {
          e.preventDefault()
        }}
        emulateTouch={true}
        width="100%"
      >
        <div>
          <img alt="Banner-001" src={banners[0]} />
        </div>
        <div>
          <img alt="Banner-002" src={banners[1]} />
        </div>
        <div>
          <img alt="Banner-003" src={banners[2]} />
        </div>
        <div>
          <img alt="Banner-004" src={banners[3]} />
        </div>
      </Carousel>
    </>
  )
}

export default Home
